export function addMenuItemFromResource(resource, staticContentPath, recents, i18n) {
    const url = resource.url;

    const icon = resource.icon;

    const recentResources = recents[resource.value];

    if (!recentResources) {
        return {
            icon,
            iconsize: 24,
            value: { source: "Element", url },
            label: resource.title,
            link: false
        };
    }

    const subMenuItemOptions = recentResources.map(element => ({
        icon,
        iconsize: 24,
        value: { source: "RecentElement", elementId: element.elementId, isRecent: true },
        label: element.name,
        link: false
    }));

    return {
        icon,
        iconsize: 24,
        label: resource.title,
        link: false,
        items: [
            {
                options: [
                    {
                        ellipsis: true,
                        label: i18n.createNew,
                        value: { source: "Element", url },
                        divider: true,
                        link: false
                    }
                ]
            },
            {
                label: i18n.recent,
                options: subMenuItemOptions
            }
        ]
    };
}
